import React, { useEffect, useState } from "react";
import axios from "axios";

function TimeCheck() {
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [selectedSubProduct, setSelectedSubProduct] = useState("");
  const [archivedOrders, setArchivedOrders] = useState([]);
  const [subProducts, setSubProducts] = useState([]);
  const [filteredData, setFilteredData] = useState([]);

  useEffect(() => {
    const fetchSubProducts = async () => {
      try {
        const response = await axios.get("/api/Product/getAllProducts");
        if (response.status === 200) {
          const allSubProducts = response.data.flatMap((product) => product.subProducts);
          setSubProducts(allSubProducts);
        } else {
          console.error("Erreur lors de la récupération des sous-produits : ", response);
        }
      } catch (error) {
        console.error("Erreur lors du chargement des sous-produits :", error.message);
      }
    };

    fetchSubProducts();
  }, []);

  useEffect(() => {
    const fetchArchivedOrders = async () => {
      try {
        const response = await axios.get("/api/ReadyOrders/getArchivedReadyOrders");
        if (response.status === 200) {
          setArchivedOrders(response.data);
        } else {
          console.error("Erreur lors de la récupération des commandes archivées : ", response);
        }
      } catch (error) {
        console.error("Erreur lors du chargement des commandes archivées :", error.message);
      }
    };

    fetchArchivedOrders();
  }, []);

  const formatDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    return date.toISOString().split("T")[0]; // YYYY-MM-DD
  };

  const calculatePreparationTime = (confirmationDate, readyTime) => {
    if (!confirmationDate || !readyTime) return 0;

    const confirmation = new Date(confirmationDate);
    const ready = new Date(readyTime);

    if (isNaN(confirmation.getTime()) || isNaN(ready.getTime())) {
      console.error("Date invalide :", { confirmationDate, readyTime });
      return 0;
    }

    const differenceInMilliseconds = ready - confirmation;
    return Math.round(differenceInMilliseconds / (1000 * 60)); // Convertir en minutes
  };

  const filterData = () => {
    if (archivedOrders.length === 0) {
        console.warn("Aucune commande archivée trouvée.");
        return;
    }

    const filtered = archivedOrders.filter((order) => {
        let isInRange = true;

        if (startDate && endDate) {
            const orderDate = new Date(order.readyTime); // Filtrage basé sur la date d'archivage
            const start = new Date(startDate);
            const end = new Date(endDate);
            isInRange = orderDate >= start && orderDate <= end;
        }

        const hasSelectedSubProduct =
            !selectedSubProduct ||
            order.items.some((item) => {
                return item.name.trim().toUpperCase() === selectedSubProduct.trim().toUpperCase();
            });

        return isInRange && hasSelectedSubProduct;
    });

    const aggregatedData = {};

    filtered.forEach((order) => {
        order.items.forEach((item) => {
            const itemNameNormalized = item.name.trim().toUpperCase();
            const selectedSubProductNormalized = selectedSubProduct.trim().toUpperCase();

            if (!selectedSubProduct || itemNameNormalized === selectedSubProductNormalized) {
                if (!aggregatedData[item.name]) {
                    aggregatedData[item.name] = { totalTime: 0, orderCount: 0, totalQuantity: 0, archiveDate: order.readyTime };
                }

                const preparationTime = calculatePreparationTime(order.confirmationDate, order.readyTime);
                
                if (preparationTime > 0) {
                    aggregatedData[item.name].totalTime += preparationTime;
                    aggregatedData[item.name].orderCount += 1; // Comptabiliser le nombre de commandes
                    aggregatedData[item.name].totalQuantity += item.quantity;
                }
            }
        });
    });

    const result = Object.keys(aggregatedData).map((key) => ({
        productName: key,
        averageTime: aggregatedData[key].orderCount > 0 ? Math.round(aggregatedData[key].totalTime / aggregatedData[key].orderCount) : 0,
        totalQuantity: aggregatedData[key].totalQuantity,
        archiveDate: formatDate(aggregatedData[key].archiveDate),
    }));

    setFilteredData(result);
};


  return (
    <div>
      <h2>Performances du Service</h2>

      <label>Date de début : </label>
      <input type="date" value={startDate} onChange={(e) => setStartDate(e.target.value)} />

      <label>Date de fin : </label>
      <input type="date" value={endDate} onChange={(e) => setEndDate(e.target.value)} />

      <label>Nature du produit : </label>
      <select value={selectedSubProduct} onChange={(e) => setSelectedSubProduct(e.target.value)}>
        <option value="">Tous</option>
        {subProducts.map((sub) => (
          <option key={sub._id} value={sub.name}>
            {sub.name}
          </option>
        ))}
      </select>

      <button onClick={filterData}>Confirmer le filtre</button>

      <table border="1">
        <thead>
          <tr>
            <th>Date d'archivage</th>
            <th>Nature de la commande</th>
            <th>Quantité totale</th>
            <th>Temps moyen de préparation (min)</th>
          </tr>
        </thead>
        <tbody>
          {filteredData.length === 0 ? (
            <tr>
              <td colSpan="4">Aucune donnée disponible</td>
            </tr>
          ) : (
            filteredData.map((data, index) => (
              <tr key={index}>
                <td>{data.archiveDate}</td>
                <td>{data.productName}</td>
                <td>{data.totalQuantity}</td>
                <td>{data.averageTime}</td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
}

export default TimeCheck;
